import { render } from "./PlaceAddPage.vue?vue&type=template&id=902ef0c8&scoped=true"
import script from "./PlaceAddPage.vue?vue&type=script&lang=js"
export * from "./PlaceAddPage.vue?vue&type=script&lang=js"

import "./PlaceAddPage.vue?vue&type=style&index=0&id=902ef0c8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-902ef0c8"]])

export default __exports__